import { DRAW_PULSE_MS, type DrawPulseState } from '@sorrem/shared';
import type { ResourceBarSweep } from '@sorrem-client/ui/components';

/**
 * The essence bar's sweep for a Draw's pulse: one pass a pulse, slower at
 * the pulse's slower speed, picked up as far along as the pulse has run
 * since the host said so (`atMs`, wall-clock ms). Each word from the host
 * (a new pulse, a change of speed) starts a fresh pass from there.
 */
export function toDrawPulseSweep(pulse: DrawPulseState | undefined, nowMs: number): ResourceBarSweep | undefined {
    if (pulse === undefined || pulse.rate <= 0) {
        return undefined;
    }
    const durationMs = DRAW_PULSE_MS / pulse.rate;
    return {
        key: `${pulse.pulsesDone}:${pulse.atMs}`,
        durationMs,
        elapsedMs: pulse.progress * durationMs + Math.max(0, nowMs - pulse.atMs),
    };
}
